module.exports = __webpack_public_path__ + "static/media/snake-t.82f5d2c6.png";